/**
 * GetSettingsResult.ts
 */
export class GetSettingsResult {
    constructor(responseCode, data) {
        this.responseCode = responseCode;
        this.data = data;
    }
    getResponseCode() {
        return this.responseCode;
    }
    getData() {
        return this.data;
    }
}
//# sourceMappingURL=GetSettingsResult.js.map